module.exports = __webpack_public_path__ + "img/monitorbox04.86c0bad8.jpg";